export function installMobileZoomGuard(documentTarget: Document = document, navigatorTarget: Navigator = navigator) {
  if (navigatorTarget.maxTouchPoints < 2) return () => undefined;

  const preventGesture = (event: Event) => event.preventDefault();
  const preventPinch = (event: TouchEvent) => {
    if (event.touches.length > 1) event.preventDefault();
  };

  documentTarget.addEventListener("gesturestart", preventGesture, { passive: false });
  documentTarget.addEventListener("gesturechange", preventGesture, { passive: false });
  documentTarget.addEventListener("gestureend", preventGesture, { passive: false });
  documentTarget.addEventListener("touchmove", preventPinch, { passive: false });

  return () => {
    documentTarget.removeEventListener("gesturestart", preventGesture);
    documentTarget.removeEventListener("gesturechange", preventGesture);
    documentTarget.removeEventListener("gestureend", preventGesture);
    documentTarget.removeEventListener("touchmove", preventPinch);
  };
}
